export const spaceName = 'pay';
export interface PaySettings {}

export default {} as PaySettings;
